module.exports = __webpack_public_path__ + "img/gh_pic03-9da8fe.png";